<template>
  <!--
      作者：kmdshop
      时间：2019-10-24
      描述：商品管理
  -->
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="出售中" name="sell"></el-tab-pane>
        <el-tab-pane label="库存紧张" name="stock"></el-tab-pane>
        <el-tab-pane label="已售罄" name="over"></el-tab-pane>
        <el-tab-pane label="已下架" name="lower"></el-tab-pane>
        <el-tab-pane label="草稿" name="draft"></el-tab-pane>
      </el-tabs>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商品分类">
          <el-select size="small" v-model="searchForm.category_id" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option label="无分类" value="-1"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品品牌">
          <el-select size="small" v-model="searchForm.brand_id" placeholder="所有品牌">
            <el-option label="全部" value="0"></el-option>
            <el-option label="无品牌" value="-1"></el-option>
            <el-option v-for="(item, index) in brand_list" :key="index" :label="item.name" :value="item.brand_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运费模板">
          <el-select size="small" v-model="searchForm.delivery_id" placeholder="不限制">
            <el-option label="全部" value="0"></el-option>
            <el-option label="无运费模板" value="-1"></el-option>
            <el-option v-for="(item, index) in delivery_list" :key="index" :label="item.name" :value="item.delivery_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品规格">
          <el-select size="small" v-model="searchForm.is_spec_type" placeholder="所有">
            <el-option label="全部" value="0"></el-option>
            <el-option label="单规格" value="10"></el-option>
            <el-option label="多规格" value="20"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="显示">
          <el-select size="small" v-model="searchForm.is_special_view" placeholder="所有">
            <el-option label="全部" value="0"></el-option>
            <el-option label="显示" value="1"></el-option>
            <el-option label="隐藏" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select size="small" v-model="searchForm.audit_status" placeholder="所有">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待审核" value="0"></el-option>
            <el-option label="已审核" value="10"></el-option>
            <el-option label="审核拒绝" value="20"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商品关键词"><el-input size="small" v-model="searchForm.product_name" placeholder="关键词搜索"></el-input></el-form-item>
        <!-- <el-form-item label="编码"><el-input size="small" v-model="searchForm.product_no" :placeholder="product_no_search"></el-input></el-form-item> -->
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加产品-->
    <!-- -->
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/product/product/add'">添加产品</el-button>
    </div>
    <div class="operaction" style="display: flex;"  v-if="supply_id==0 || (supply_id!=0 && supply_setting.product_product_op == '1')">
      <div class="common-level-rail" style="margin-right:20px;"><el-button size="small"  @click="batch_shelves" >批量上架</el-button></div>
      <div class="common-level-rail" style="margin-right:20px;"><el-button size="small"  @click="batch_UnShelve" >批量下架</el-button></div>
     <!--  <div class="common-level-rail" style="margin-right:20px;"><el-button size="small"  @click="batch_stock" >批量修改库存</el-button></div>
      <div class="common-level-rail" style="margin-right:20px;"><el-button size="small"  @click="batch_income" >批量修改直推收益</el-button></div> -->
      <div class="common-level-rail" style="margin-right:20px;"><el-button size="small"  @click="importGoods">商品导入</el-button></div>
      <div class="common-level-rail" style="margin-right:20px;"><el-button size="small"  @click="exportGoods">商品导出</el-button></div>
      <div class="common-level-rail" style="margin-right:20px;"><el-button size="small"  @click="moreActions">更多操作</el-button></div>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection"  width="45"></el-table-column>
          <el-table-column prop="product_name" label="产品" width="300px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image[0]?scope.row.image[0].file_path:error_img" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="price">￥{{ scope.row.product_price }}</div>
                  <div class="name" v-if="scope.row.supply_id>0">供应商：{{ scope.row.supply?scope.row.supply.name:'' }}
                    <span v-if="scope.row.supply && scope.row.supply.self_manage>0">(自营)</span>
                  </div>
                  <!-- <div>
                    <el-tag size="mini" v-for="(tag,index) in scope.row.labels" :key="tag.name" > {{tag.name}} </el-tag>
                  </div> -->
                  <!-- <div>
                    <el-tag size="mini" > {{scope.row.audit_status_text}} </el-tag>
                  </div> -->
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="category.name" label="分类"></el-table-column>
          <el-table-column prop="brand_name" label="品牌"></el-table-column>
          <el-table-column prop="sales_actual" label="实际销量"></el-table-column>
          <el-table-column prop="product_stock" label="库存">
            <template slot-scope="scope">
              <span v-if="scope.row.product_stock <=0">已售罄</span>
              <span v-else>{{scope.row.product_stock}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="view_times" label="点击数"></el-table-column>
          <el-table-column prop="product_status.text" label="状态">
            <template slot-scope="scope">
              <span :class="{ green: scope.row.product_status.value == 10, gray: scope.row.product_status.value == 20 }">{{ scope.row.product_status.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="product_status.text" label="商品属性">
            <template slot-scope="scope">
              <span v-if="scope.row.is_virtual == 0">实物商品</span>
              <span v-if="scope.row.is_virtual == 1" class="green">虚拟商品</span>
            </template>
          </el-table-column>
          <el-table-column prop="is_special_view" width="100" label="显示类型">
            <template slot-scope="scope">
              <p v-if="scope.row.is_special_view==1" class="green">隐藏</p>
              <p v-else>显示</p>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="发布时间"></el-table-column>
          <el-table-column prop="product_sort" label="排序">
            <template slot-scope="scope">
              <el-input type="number" @change="changeProductSort(scope.row)" v-model="scope.row.product_sort"></el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              
              <el-button  @click="openPopup(scope.row,'product')" type="text" size="small">页面链接</el-button>
              <!-- v-if="supply_id==0 || (supply_id!=0 && supply_setting.product_shelf_edit == '1' && scope.row.product_status.value==10)
              
              "
              -->
              <el-button @click="editClick(scope.row)" type="text" size="small" 
             
              v-auth="'/product/product/edit'">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/product/product/delete'">删除</el-button>
              <el-button @click="copyClick(scope.row)" type="text" size="small" v-auth="'/product/product/copy'">一键复制</el-button>
              <!-- v-auth="'/product/product/remark'" -->
              <el-button @click="remark(scope.row)" type="text" size="small">备注</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

    <el-dialog title="订单备注" :visible.sync="remarkDialogFormVisible">
      <el-form :model="remarkForm">
        <el-form-item label="备注" label-width="50px">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入备注内容" v-model="remarkForm.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogFormVisible = false" :loading="remarkDialogLoading">取 消</el-button>
        <el-button type="primary" @click="editRemark" :loading="remarkDialogLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 上传导入组件  -->
    <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>
    <!-- 更多操作组件  -->
    <Actions v-if="more_actions" @closeDialog="closeDialogFunc($event,'action')"></Actions>
    <!--页面链接-->
    <LinkPage v-if="show_path" :is_open="show_path" :path_type="path_type" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'path')"></LinkPage>
  </div>
</template>

<script>
import ProductApi from '@/api/product.js';
import Upload from '@/components/file/import';
import Actions from '@/components/product/Actions';
import LinkPage from '@/components/page/path';
import qs from 'qs';
import { setCookie,getCookie } from '@/utils/base';
export default {
  components: {
    Upload,
    Actions,
    LinkPage
  },
  data() {
    return {
       path_type:'',
        show_path:false,
      /*切换菜单*/
      activeName: 'all',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        product_name: '',
        category_id: '',
        delivery_id: '',
        product_no:'',
        is_special_view:'',
        brand_id:'',
        is_spec_type:"",
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      // 全部品牌
      brand_list: [],
      delivery_list: [],
      /*选中的*/
      multipleSelection: [],
      /*选择的商品列表*/
      select_list:[],
      /*是否显示*/
      dialogVisible: false,
      open_upload:false,
      // 导入类型
      import_type:'goods',
      // 是否加载操作页面
      more_actions:false,
      product_no_search:'',
      error_img:'',
      wxapp_id:'',
      remarkDialogFormVisible: false,
      remarkDialogLoading: false,
      remarkForm: {
        remark: ''
      },
      supply_id:getCookie("is_supply")?getCookie("is_supply"):0,
      supply_setting:{}
    };
  },
  created() {
    /*获取列表*/
    this.getData();

  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.type = self.activeName;
      self.loading = true;
      ProductApi.productList(Params, true)
        .then(data => {
          if(data.data.product_vars.product_default_image){
              self.error_img = data.data.product_vars.product_default_image.file_path
          }

          self.loading = false;
          self.tableData = data.data.list.data;
          self.supply_setting = data.data.supply_setting
;
          
          self.categoryList = data.data.catgory;
          self.totalDataNumber = data.data.list.total;
          self.brand_list = data.data.brand_list;
          self.delivery_list = data.data.delivery_list;
          var product_no_text = data.data.product_vars.product_no_text;
          var product_diy_no_text = data.data.product_vars.product_diy_no_text;
          if(!product_no_text){
            product_no_text='商品编码';
          }
          if(!product_diy_no_text){
            product_diy_no_text='商品自编码';
          }
          self.product_no_search = product_no_text+"/"+product_diy_no_text;
          self.wxapp_id = data.data.wxapp_id;

        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*打开添加*/
    addClick() {
      this.$router.push('/product/product/add');
    },
    /*批量上架*/
    batch_shelves() {
        let product_ids=[];
        let params = this.multipleSelection;
        params.forEach((param)=>{
          product_ids.push(param.product_id);
        })
        product_ids=product_ids.join(',');
      // console.log(product_ids);
        if(product_ids==''){
          this.$message({
            message: '请选择要上架的商品',
            type: 'error'
          });
        }else{
          ProductApi.batchProduct({
            product_ids: product_ids
          }).then(data => {
            this.$message({
              message: '批量上架成功',
              type: 'success'
            });
            this.getData();
          });
        }

    },
    /*批量下架*/
    batch_UnShelve() {
      let product_ids=[];
      let params = this.multipleSelection;
      params.forEach((param)=>{
        product_ids.push(param.product_id);
      })
      product_ids=product_ids.join(',');
      if(product_ids==''){
        this.$message({
          message: '请选择要下架的商品',
          type: 'error'
        });
      }else{
        ProductApi.batch_UnshelveProduct({
          product_ids: product_ids
        }).then(data => {
          this.$message({
            message: '批量下架成功',
            type: 'success'
          });
          this.getData();
        });
      }
    },
    /*选择商品*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },


    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          product_id: row.product_id,
          scene: 'edit'
        }
      });
    },

    /*打开复制*/
    copyClick(row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          product_id: row.product_id,
          scene: 'copy'
        }
      });
    },

    /*打开复制*/
    remark(row) {
      this.remarkForm.product_id = row.product_id
      this.remarkForm.remark = row.remark
      this.remarkDialogFormVisible = true
    },

    // 编辑备注
    editRemark() {
      let self = this
      self.remarkDialogLoading = true
      ProductApi.editRemark(this.remarkForm).then(data => {
        self.$message({
          message: data.msg,
          type: 'success'
        });
        self.remarkDialogLoading = false
        self.remarkDialogFormVisible = false
      });
    },

    // 商品导入
    importGoods:function(row){
      this.open_upload = true
    },

    // 更多操作
    moreActions:function(row){
      this.more_actions = true
    },

    // 商品导出
    exportGoods:function(){
      // 勾选需要导出的商品
      let product_ids = [];
      let params = this.multipleSelection;
      params.forEach((param)=>{
        product_ids.push(param.product_id);
      })
      product_ids = product_ids.join(',');
      // 筛选条件
      // 商品状态

      // console.log(this.searchForm)
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/product.product/exportGoods?' + qs.stringify(this.searchForm)+'&goods_ids='+product_ids;
    },
      openPopup(item,type){
        this.dataModel = item;
        this.dataModel.wxapp_id = this.wxapp_id;
        this.show_path = true;
        this.path_type = type;
      },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
        if (f == 'upload') {
            this.open_upload = e.openDialog;
            if (e.type == 'success') {
                  this.getData();
            }
        }else if(f == 'action'){
          this.more_actions = e.openDialog;
          if (e.type == 'success') {
                this.getData();
          }
        }else if (f == 'path') {
              this.show_path = e.openDialog;
          }
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        })
        .then(() => {
          ProductApi.delProduct({
            product_id: row.product_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
    },
    /*
    修改商品排序
    */
    changeProductSort(e){
      let self = this;
      let Params = {};
      Params.product_id = e.product_id;
      Params.product_sort = e.product_sort;
      Params.scene = 'sort'
      self.loading = true;
      ProductApi.editProduct(Params, true)
        .then(data => {
          self.loading = false;


        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/index.vue